import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid,
} from '@mui/material';
import Buttons from '../../../../../components/buttons';
import EditorControls from '../../../../BaseEditor/editorControls';
// import PeriodForm from '../../../../../components/bootStrap/periodform';
// import { periodVarians } from '../../../../../constants/date';

function fromatDate(date) {
  const d = new Date(date);
  return d.toLocaleDateString('uk', { day: 'numeric', month: 'short', year: '2-digit' });
}
function SetPeriodButton({
  disabled,
  onChange,
  value,
}) {
  const [opened, setOpened] = useState(false);
  const [localValue, setLocalValue] = useState(value);
  useEffect(
    () => setLocalValue(value),
    [value],
  );
  const content = useMemo(
    () => {
      if (value.start && value.end) return `${fromatDate(value.start)} - ${fromatDate(value.end)}`;
      if (value.end) return `по ${fromatDate(value.end)}`;
      if (value.start) return `з ${fromatDate(value.start)}`;
      return 'Не встановлено';
    },
    [value.end, value.start],
  );
  return (
    <>
      <Buttons.PeriodButton
        onClick={() => setOpened(true)}
        content={content}
        disabled={disabled}
      />
      <Dialog open={opened} onClose={() => setOpened(false)}>
        <DialogTitle>
          Оберіть період
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 0 }}>
            <Grid item sm={6}>
              <EditorControls.DateInput
                label="З"
                value={localValue.start}
                onChange={(e, v) => setLocalValue((r) => ({ ...r, start: v }))}
              />
            </Grid>
            <Grid item sm={6}>
              <EditorControls.DateInput
                label="по"
                value={localValue.end}
                onChange={(e, v) => setLocalValue((r) => ({ ...r, end: v }))}
              />
            </Grid>
          </Grid>
          {/* <PeriodForm value={localValue} onChange={(e, v) => setLocalValue(v)} /> */}
        </DialogContent>
        <DialogActions>
          <Button
            color="success"
            onClick={(e) => {
              setOpened(false);
              onChange(e, localValue);
            }}
          >
            Встановити
          </Button>
          <Button color="secondary" onClick={() => setOpened(false)}>
            Закрити
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

SetPeriodButton.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string,
    // variant: PropTypes.oneOf(Object.keys(periodVarians)),
  }).isRequired,
};
SetPeriodButton.defaultProps = {
  disabled: false,
};

export default SetPeriodButton;
